// Cada entorno usa el mismo logo con un color propio, para distinguirlos en las pestañas.
const ENTORNOS = {
  admin: { favicon: '/favicon-admin.png', icono: '/icon-admin-180.png', titulo: 'Super admin · Udream' },
  portal: { favicon: '/favicon-portal.png', icono: '/icon-portal-180.png', titulo: 'Portal de clientes · Udream' },
  crm: { favicon: '/favicon-crm.png', icono: '/icon-crm-180.png', titulo: 'Udream App' },
};

export const entornoActual = () => {
  const h = window.location.hostname;
  if (h.startsWith('admin.')) return 'admin';
  if (h.startsWith('clientes.')) return 'portal';
  return 'crm';
};

export function aplicarIdentidad() {
  const e = ENTORNOS[entornoActual()];
  const poner = (rel, href, extra = {}) => {
    let l = document.querySelector(`link[rel="${rel}"]`);
    if (!l) { l = document.createElement('link'); l.rel = rel; document.head.appendChild(l); }
    l.href = href + '?v=3';
    Object.entries(extra).forEach(([k, v]) => l.setAttribute(k, v));
  };
  poner('icon', e.favicon, { type: 'image/png' });
  poner('shortcut icon', e.favicon, { type: 'image/png' });
  poner('apple-touch-icon', e.icono);
  if (document.title === 'Udream App' || !document.title) document.title = e.titulo;
}

export const iconoDelEntorno = () => ENTORNOS[entornoActual()].icono;
